import { Component } from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import API from "../../../../utils/API";

class DisconnectPrinterModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            activePrinterDevices: [],
            options: [],
            selectedPrinterDevice: null,
            selectedPrinterDeviceFriendlyName: props.printer ? props.printer.friendlyName : '',
            requiredFieldsFilled: false,
        }
    }


    disconnectPrinter = async () => {
        const { toggle, checkInAppConfiguration, printer } = this.props;
        const payload = {
            organizationId: '',
            eventId: '',
            printerDeviceId: printer._id,
            friendlyName: this.state.selectedPrinterDeviceFriendlyName,
        };

        await API().patch(`/patchActivePrinterDevice`, payload).then((res) => {
            if (res.data) {
                let updatedActivePrinterDevices = checkInAppConfiguration.printerDevices || [];
                let updatedPrinterDevice = res.data.printerDevice;
                const existingIndex = updatedActivePrinterDevices.findIndex(device => device._id === updatedPrinterDevice._id);
                if (existingIndex !== -1) {
                    updatedActivePrinterDevices.splice(existingIndex, 1);
                }
                this.props.updatedActivePrinterDevices(updatedActivePrinterDevices);
                toggle();
            }
        });
    }

    render() {
        const { isOpen, toggle, printer } = this.props;
        const { submitting } = this.state;


        return <div>
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle={"Disconnect Printer"}
                bodyHeaderText={''}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div>
                            <p>Are you sure you want to disconnect the printer <strong>{printer ? printer.friendlyName : ''}</strong>?</p>
                        </div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Disconnect ' : 'Disconnecting...'}
                actionButton={() => this.disconnectPrinter()}
                actionButtonDisabled={submitting}
            ></FieldModal>
        </div>
    }
}

export default DisconnectPrinterModal;